module.exports = __webpack_public_path__ + "img/88.f269f420.jpg";